import {request} from "./api";

export const get = (data) => {
    return request(`/admin/barcodes?${new URLSearchParams(data).toString()}`, {});
};

export const getTotalIssued = (benefitId, fromUntil) => {
    return request(`/statistics/benefits/${benefitId}`, {
        method: 'POST',
        body: JSON.stringify(fromUntil === undefined ? {} : fromUntil)
    });
};